import { InfoModal } from "@starrez/starryui";
import * as React from "react";
import { ButtonBarButton, ButtonBarCenter } from "../../../../../components/ButtonBar/ButtonBar.styles";
import { Button } from "../../../../../components/Buttons/Button";
import { strings } from "../../../../../localisation";
import { TemplateChangedModalDiv } from "./TemplateChangeModal.styles";

export interface ITemplateChangeModalProps {
    OnConfirm: (selectedTemplateID: number) => void;
    OnClose: () => void;
    NewTemplateID: number;
}

export const TemplateChangeModal = React.memo(({ NewTemplateID, OnConfirm, OnClose }: ITemplateChangeModalProps) => {
    return (
        <InfoModal
            Header={strings.Message_Wizard_TemplateSelection_TemplateChangeHeader}
            InfoType={"Error"}
            ListenToBackgroundClick={false}
            OnCloseRequest={OnClose}
            RenderFooter={() => (
                <ButtonBarCenter>
                    <ButtonBarButton>
                        <Button
                            variant={"Tertiary"}
                            onClick={OnClose}>
                            {strings.Action_Cancel}
                        </Button>
                    </ButtonBarButton>
                    <ButtonBarButton>
                        <Button
                            variant={"Primary"}
                            onClick={() => {
                                OnConfirm(NewTemplateID);
                                OnClose();
                            }}>
                            {strings.Action_TemplateChange_Confirm}
                        </Button>
                    </ButtonBarButton>
                </ButtonBarCenter>
            )}
        >
            <TemplateChangedModalDiv>
                <p>
                    {strings.Message_Wizard_TemplateSelection_TemplateChangeBody}
                </p>
                <p>
                    {strings.Message_Wizard_TemplateSelection_TemplateChangeConfirm}
                </p>
            </TemplateChangedModalDiv>
        </InfoModal>
    );
}, () => true);
